const moment = require('moment-timezone')

export default class TzMoment {
    constructor(timezone) {
        this.moment = moment.tz.setDefault(timezone)
    }
}
